export const CHOOSE_AN_ARTISTIC_STYLE_FOR_YOUR_IMAGE =
  'Choose an artistic style for your image'
export const ADD_DETAILS_OPTIONAL = 'Add details (optional)'
export const DESCRIBE_A_BACKGROUND_IMAGE = 'Describe a background image'
export const CLEAR_TEXT = 'Clear text'
export const CREATE_VIRTUAL_BACKGROUNDS_WITH_AI_COMPANION =
  'Create virtual backgrounds with AI Companion'
export const GENERATE = 'Generate'
export const GENERATING = 'Generating'
export const IMAGES_FAILED_TO_GENERATE_PLEASE_TRY_AGAIN =
  'Images failed to generate. Please try again.'
export const IMAGES_MAY_TAKE_ABOUT_A_MINUTE_TO_GENERATE =
  'Images may take about a minute to generate.'
export const WE_ADJUSTED_YOUR_PROMPT_TO_FOLLOW_OUR_CONTENT_GUIDELINES =
  'We adjusted your prompt to follow our content guidelines'
export const SAVE_BACKGROUND = 'Save background'
export const SHOWING_RESULTS = 'Showing results'
export const TRY_AGAIN = 'Try again'
export const TRY_THESE_VIRTUAL_BACKGROUND_IDEAS =
  'Try these virtual background ideas'
export const TEXT_LIMIT_HAS_BEEN_REACHED = 'Text limit has been reached'
export const UNABLE_TO_CREATE_AN_IMAGE_WITH_THIS_PROMPT_PLEASE_TRY_ANOTHER_PROMPT =
  'Unable to create an image with this prompt. Please try another prompt.'
export const YOUR_IMAGE_HAS_BEEN_SAVED = 'Your image has been saved.'

const resources = {
  en: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Chinese Painting',
      'Choose an artistic style for your image':
        'Choose an artistic style for your image',
      Cinematic: 'Cinematic',
      'City skyline at night': 'City skyline at night',
      'Classic theater': 'Classic theater',
      'Clear text': 'Clear text',
      'Clouds viewed from a mountain peak':
        'Clouds viewed from a mountain peak',
      Comic: 'Comic',
      'Conference room with view of the mountains':
        'Conference room with view of the mountains',
      'Cozy living room': 'Cozy living room',
      'Coffee shop': 'Coffee shop',
      'Create virtual backgrounds with AI Companion':
        'Create virtual backgrounds',
      'Add details (optional)': 'Add details (optional)',
      'Describe a background image': 'Describe a background image',
      None: 'None',
      Office: 'Office',
      Bookshelf: 'Bookshelf',
      Fantasy: 'Fantasy',
      Generate: 'Generate',
      Generating: 'Generating',
      'Images failed to generate. Please try again.':
        'Images failed to generate. Please try again.',
      'Images may take about a minute to generate.':
        'Images may take about a minute to generate.',
      'Professional office': 'Professional office',
      Space: 'Space',
      'Style (optional)': 'Style (optional)',
      'Select a space': 'Select a space',
      'Select style': 'Select style',
      'Tropical beach': 'Tropical beach',
      'We adjusted your prompt to follow our content guidelines':
        'We adjusted your prompt to follow our content guidelines',
      'Japanese Ukiyo-E': 'Japanese Ukiyo-E',
      'Kelp forest': 'Kelp forest',
      'Lake in front of mountain during autumn':
        'Lake in front of mountain during autumn',
      Manga: 'Manga',
      'Mid-century modern library': 'Mid-century modern library',
      'Modern office overlooking a beach': 'Modern office overlooking a beach',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Outdoor garden with blooming flowers',
      'Paper Cut': 'Paper Cut',
      'Pencil Sketch': 'Pencil Sketch',
      'Pixel Art': 'Pixel Art',
      'River passing through a canyon': 'River passing through a canyon',
      'Rolling hills at dawn': 'Rolling hills at dawn',
      'Sand dunes during sunset': 'Sand dunes during sunset',
      'Save background': 'Save background',
      'Showing results': 'Showing results',
      'Try again': 'Try again',
      'Try these virtual background ideas':
        'Try these virtual background ideas',
      'Text limit has been reached': 'Text limit has been reached',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Unable to create an image with this prompt. Please try another prompt.',
      'University lecture hall': 'University lecture hall',
      Watercolor: 'Watercolor',
      'Waterfall in a tropical jungle': 'Waterfall in a tropical jungle',
      'Your image has been saved.': 'Your image has been saved.',
    },
  },
  de: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Chinesische Malerei',
      'Choose an artistic style for your image':
        'Wählen Sie einen künstlerischen Stil für Ihr Bild',
      Cinematic: 'Filmkunst',
      'City skyline at night': 'Stadtskyline bei Nacht',
      'Classic theater': 'Klassisches Theater',
      'Clear text': 'Text löschen',
      'Clouds viewed from a mountain peak':
        'Wolken von einem Berggipfel aus gesehen',
      Comic: 'Comic',
      'Conference room with view of the mountains':
        'Konferenzraum mit Blick auf die Berge',
      'Cozy living room': 'Gemütliches Wohnzimmer',
      'Coffee shop': 'Coffeeshop',
      'Create virtual backgrounds with AI Companion':
        'Virtuelle Hintergründe erstellen',
      'Add details (optional)': 'Details hinzufügen (optional)',
      'Describe a background image': 'Beschreiben Sie ein Hintergrundbild',
      None: 'Keines',
      Office: 'Büro',
      Bookshelf: 'Bücherregal',
      Fantasy: 'Fantasie',
      Generate: 'Erstellen',
      Generating: 'Wird generiert …',
      'Images failed to generate. Please try again.':
        'Bilder konnten nicht generiert werden. Versuchen Sie es erneut.',
      'Images may take about a minute to generate.':
        'Die Erzeugung von Bildern kann etwa eine Minute dauern',
      'Professional office': 'Professionelles Büro',
      Space: 'Raum',
      'Style (optional)': 'Stil (optional)',
      'Select a space': 'Wählen Sie einen Raum',
      'Select style': 'Stil auswählen',
      'Tropical beach': 'Tropischer Strand',
      'We adjusted your prompt to follow our content guidelines':
        'Wir haben Ihren Prompt an unsere Inhaltsrichtlinien angepasst.',
      'Japanese Ukiyo-E': 'Japanisches Ukiyo-E',
      'Kelp forest': 'Kelpwald',
      'Lake in front of mountain during autumn': 'See vor dem Berg im Herbst',
      Manga: 'Manga',
      'Mid-century modern library': 'Bibliothek im Nachkriegsstil',
      'Modern office overlooking a beach':
        'Modernes Büro mit Blick auf einen Strand',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Garten im Freien mit blühenden Blumen',
      'Paper Cut': 'Paper Cut',
      'Pencil Sketch': 'Bleistift-Skizze',
      'Pixel Art': 'Pixelkunst',
      'River passing through a canyon': 'Durch eine Schlucht fließender Fluss',
      'Rolling hills at dawn': 'Sanfte Hügel im Morgengrauen',
      'Sand dunes during sunset': 'Sanddünen bei Sonnenuntergang',
      'Save background': 'Hintergrund speichern',
      'Showing results': 'Ergebnisse werden angezeigt',
      'Try again': 'Erneut versuchen',
      'Try these virtual background ideas':
        'Probieren Sie diese Ideen für virtuelle Hintergründe aus',
      'Text limit has been reached': 'Textlimit wurde erreicht',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Mit dieser Eingabeaufforderung kann kein Bild erstellt werden. Bitte versuchen Sie es mit einer anderen Eingabeaufforderung',
      'University lecture hall': 'Universitäts-Hörsaal',
      Watercolor: 'Aquarell',
      'Waterfall in a tropical jungle': 'Wasserfall im tropischen Dschungel',
      'Your image has been saved.': 'Ihr Bild wurde gespeichert',
    },
  },
  es: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Pintura china',
      'Choose an artistic style for your image':
        'Seleccione un estilo artístico para su imagen',
      Cinematic: 'Cinematográfico',
      'City skyline at night': 'Horizonte urbano por la noche',
      'Classic theater': 'Teatro clásico',
      'Clear text': 'Borrar texto',
      'Clouds viewed from a mountain peak':
        'Nubes desde la cumbre de una montaña',
      Comic: 'Comic',
      'Conference room with view of the mountains':
        'Sala de conferencias con vistas a las montañas',
      'Cozy living room': 'Sala de estar acogedora',
      'Coffee shop': 'Cafetería',
      'Create virtual backgrounds with AI Companion': 'Crear fondos virtuales',
      'Add details (optional)': 'Añadir detalles (opcional)',
      'Describe a background image': 'Describa una imagen de fondo',
      None: 'Ninguno',
      Office: 'Oficina',
      Bookshelf: 'Biblioteca',
      Fantasy: 'Fantasía',
      Generate: 'Generar',
      Generating: 'Generando',
      'Images failed to generate. Please try again.':
        'Error al generar imágenes. Inténtelo de nuevo.',
      'Images may take about a minute to generate.':
        'Las imágenes pueden tardar aproximadamente un minuto en generarse',
      'Professional office': 'Oficina profesional',
      Space: 'Espacio',
      'Style (optional)': 'Estilo (opcional)',
      'Select a space': 'Seleccione un espacio',
      'Select style': 'Seleccionar estilo',
      'Tropical beach': 'Playa tropical',
      'We adjusted your prompt to follow our content guidelines':
        'Hemos ajustado su prompt para que siga nuestras normas de contenido',
      'Japanese Ukiyo-E': 'Ukiyo-e japonés',
      'Kelp forest': 'Bosque de algas marinas',
      'Lake in front of mountain during autumn':
        'Lago frente a la montaña durante el otoño',
      Manga: 'Manga',
      'Mid-century modern library':
        'Librería de estilo moderno de mediados de siglo',
      'Modern office overlooking a beach':
        'Oficina moderna con vistas a la playa',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers': 'Jardín con flores',
      'Paper Cut': 'Collage',
      'Pencil Sketch': 'Boceto a lápiz',
      'Pixel Art': 'Pixel Art',
      'River passing through a canyon': 'Río transcurriendo por un cañón',
      'Rolling hills at dawn': 'Colinas al atardecer',
      'Sand dunes during sunset': 'Dunas de arena durante la puesta de sol',
      'Save background': 'Guardar fondo',
      'Showing results': 'Mostrando resultados',
      'Try again': 'Intentar de nuevo',
      'Try these virtual background ideas':
        'Pruebe estas ideas de fondos virtuales',
      'Text limit has been reached':
        'Se ha alcanzado el límite de texto',
      'Unable to create an image with this prompt. Please try another prompt.':
        'No es posible crear una imagen con esta instrucción. Pruebe con otra instrucción.',
      'University lecture hall': 'Aula universitaria',
      Watercolor: 'Acuarela',
      'Waterfall in a tropical jungle': 'Cascada en una selva tropical',
      'Your image has been saved.': 'Su imagen se ha guardado',
    },
  },
  fr: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Peinture chinoise',
      'Choose an artistic style for your image':
        'Choisissez un style artistique pour votre image',
      Cinematic: 'Cinématique',
      'City skyline at night': 'Horizon de la ville la nuit',
      'Classic theater': 'Théâtre classique',
      'Clear text': 'Effacer le texte',
      'Clouds viewed from a mountain peak':
        'Nuages vus d’un sommet de montagne',
      Comic: 'Comique',
      'Conference room with view of the mountains':
        'Salle de conférence avec vue sur les montagnes',
      'Cozy living room': 'Salon confortable',
      'Coffee shop': 'Café',
      'Create virtual backgrounds with AI Companion':
        'Créer des arrière-plans virtuels',
      'Add details (optional)': 'Ajouter des détails (optionnel)',
      'Describe a background image': 'Décrire une image d’arrière-plan',
      None: 'Aucune',
      Office: 'Bureau',
      Bookshelf: 'Bibliothèque',
      Fantasy: 'Fantaisie',
      Generate: 'Générer',
      Generating: 'Génération en cours',
      'Images failed to generate. Please try again.':
        'Les images n’ont pas pu être générées. Veuillez réessayer.',
      'Images may take about a minute to generate.':
        'La génération des images peut prendre environ une minute',
      'Professional office': 'Bureau professionnel',
      Space: 'Espace',
      'Style (optional)': 'Style (optionnel)',
      'Select a space': 'Sélectionner un espace',
      'Select style': 'Sélectionner le style',
      'Tropical beach': 'Plage tropicale',
      'We adjusted your prompt to follow our content guidelines':
        'Nous avons adapté votre requête afin qu’elle respecte nos directives de contenu',
      'Japanese Ukiyo-E': 'Ukiyo-E japonais',
      'Kelp forest': 'Forêt de varech',
      'Lake in front of mountain during autumn':
        'Lac face à la montagne en automne',
      Manga: 'Manga',
      'Mid-century modern library': 'Bibliothèque moderne du milieu du siècle',
      'Modern office overlooking a beach':
        'Bureau moderne avec vue sur une plage',
      Neonpunk: 'Néonpunk',
      'Outdoor garden with blooming flowers':
        'Jardin extérieur avec des fleurs',
      'Paper Cut': 'Papier découpé',
      'Pencil Sketch': 'Croquis au crayon',
      'Pixel Art': 'Pixel Art',
      'River passing through a canyon': 'Rivière traversant un canyon',
      'Rolling hills at dawn': 'Collines à l’aube',
      'Sand dunes during sunset': 'Dunes de sable au coucher du soleil',
      'Save background': 'Enregistrer l’arrière-plan',
      'Showing results': 'Afficher les résultats',
      'Try again': 'Réessayer',
      'Try these virtual background ideas':
        'Essayez ces idées d’arrière-plan virtuel',
      'Text limit has been reached': 'Limite de texte atteinte',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Impossible de créer une image à l’aide de cette requête. Veuillez essayer une autre requête.',
      'University lecture hall': 'Amphithéâtre de l’université',
      Watercolor: 'Aquarelle',
      'Waterfall in a tropical jungle': 'Cascade dans une jungle tropicale',
      'Your image has been saved.': 'Votre image a été enregistrée',
    },
  },
  id: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Lukisan Tionghoa',
      'Choose an artistic style for your image':
        'Pilih gaya artistik untuk gambar Anda',
      Cinematic: 'Sinematik',
      'City skyline at night': 'Cakrawala kota di malam hari',
      'Classic theater': 'Teater klasik',
      'Clear text': 'Hapus teks',
      'Clouds viewed from a mountain peak':
        'Pemandangan awan dari puncak gunung',
      Comic: 'Komik',
      'Conference room with view of the mountains':
        'Ruang konferensi dengan pemandangan pegunungan',
      'Cozy living room': 'Ruang tamu nyaman',
      'Coffee shop': 'Kedai kopi',
      'Create virtual backgrounds with AI Companion':
        'Buat latar belakang virtual',
      'Add details (optional)': 'Tambahkan detail (opsional)',
      'Describe a background image':
        'Deskripsikan gambar latar belakang',
      None: 'Tidak ada',
      Office: 'Kantor',
      Bookshelf: 'Rak buku',
      Fantasy: 'Fantasi',
      Generate: 'Buat',
      Generating: 'Membuat',
      'Images failed to generate. Please try again.':
        'Gambar gagal dibuat. Silakan coba lagi.',
      'Images may take about a minute to generate.':
        'Pembuatan gambar mungkin memerlukan waktu sekitar satu menit',
      'Professional office': 'Kantor profesional',
      Space: 'Ruang',
      'Style (optional)': 'Gaya (opsional)',
      'Select a space': 'Pilih ruang',
      'Select style': 'Pilih gaya',
      'Tropical beach': 'Pantai tropis',
      'We adjusted your prompt to follow our content guidelines':
        'Kami menyesuaikan perintah Anda agar mengikuti pedoman konten kami',
      'Japanese Ukiyo-E': 'Ukiyo-E Jepang',
      'Kelp forest': 'Hutan ganggang',
      'Lake in front of mountain during autumn':
        'Danau di depan gunung saat musim gugur',
      Manga: 'Manga',
      'Mid-century modern library': 'Pustaka modern abad pertengahan',
      'Modern office overlooking a beach':
        'Kantor modern yang menghadap ke pantai',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Taman luar ruangan dengan bunga-bunga yang bermekaran',
      'Paper Cut': 'Potongan Kertas',
      'Pencil Sketch': 'Sketsa Pensil',
      'Pixel Art': 'Seni Piksel',
      'River passing through a canyon': 'Sungai yang melewati ngarai',
      'Rolling hills at dawn': 'Perbukitan saat fajar menyingsing',
      'Sand dunes during sunset': 'Bukit pasir saat matahari terbenam',
      'Save background': 'Simpan latar belakang',
      'Showing results': 'Menampilkan hasil',
      'Try again': 'Coba lagi',
      'Try these virtual background ideas':
        'Coba ide latar belakang virtual ini',
      'Text limit has been reached': 'Batas teks telah tercapai',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Tidak dapat membuat gambar dengan perintah ini. Coba perintah lain',
      'University lecture hall': 'Ruang kuliah universitas',
      Watercolor: 'Cat air',
      'Waterfall in a tropical jungle': 'Air terjun di hutan tropis',
      'Your image has been saved.': 'Gambar Anda telah disimpan',
    },
  },
  it: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Pittura cinese',
      'Choose an artistic style for your image':
        'Scegli uno stile artistico per la tua immagine',
      Cinematic: 'Cinema',
      'City skyline at night': 'Orizzonte urbano di notte',
      'Classic theater': 'Teatro classico',
      'Clear text': 'Cancella testo',
      'Clouds viewed from a mountain peak':
        'Nuvole viste dalla cima di una montagna',
      Comic: 'Fumetti',
      'Conference room with view of the mountains':
        'Sala conferenze con vista sulle montagne',
      'Cozy living room': 'Salotto accogliente',
      'Coffee shop': 'Caffetteria',
      'Create virtual backgrounds with AI Companion': 'Crea sfondi virtuali',
      'Add details (optional)': 'Aggiungi dettagli (facoltativo)',
      'Describe a background image': 'Descrivi un’immagine di sfondo',
      None: 'Nessuno',
      Office: 'Ufficio',
      Bookshelf: 'Scaffale',
      Fantasy: 'Fantasia',
      Generate: 'Genera',
      Generating: 'Generazione in corso',
      'Images failed to generate. Please try again.':
        'Impossibile generare le immagini. Riprova.',
      'Images may take about a minute to generate.':
        'La generazione delle immagini potrebbe richiedere circa un minuto',
      'Professional office': 'Ufficio professionale',
      Space: 'Spazio',
      'Style (optional)': 'Stile (facoltativo)',
      'Select a space': 'Seleziona uno spazio',
      'Select style': 'Seleziona stile',
      'Tropical beach': 'Spiaggia tropicale',
      'We adjusted your prompt to follow our content guidelines':
        'Abbiamo modificato il tuo prompt per seguire le nostre linee guida sui contenuti',
      'Japanese Ukiyo-E': 'Ukiyo-E giapponese',
      'Kelp forest': 'Foresta di alghe',
      'Lake in front of mountain during autumn':
        'Lago davanti a una montagna in autunno',
      Manga: 'Manga',
      'Mid-century modern library': 'Biblioteca moderna della metà del secolo',
      'Modern office overlooking a beach':
        'Ufficio moderno con vista su una spiaggia',
      Neonpunk: 'Neon punk',
      'Outdoor garden with blooming flowers':
        'Giardino esterno con fiori che sbocciano',
      'Paper Cut': 'Intaglio carta',
      'Pencil Sketch': 'Schizzo a matita',
      'Pixel Art': 'Pixel art',
      'River passing through a canyon': 'Fiume che attraversa un canyon',
      'Rolling hills at dawn': 'Colline ondulate all’alba',
      'Sand dunes during sunset': 'Dune di sabbia al tramonto',
      'Save background': 'Salva sfondo',
      'Showing results': 'Visualizzazione dei risultati',
      'Try again': 'Riprova',
      'Try these virtual background ideas':
        'Prova queste idee per lo sfondo virtuale',
      'Text limit has been reached': 'Limite di testo raggiunto',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Impossibile creare un’immagine con questa richiesta. Prova un’altra richiesta',
      'University lecture hall': 'Aula universitaria',
      Watercolor: 'Acquerello',
      'Waterfall in a tropical jungle': 'Cascata in una giungla tropicale',
      'Your image has been saved.': 'La tua immagine è stata salvata',
    },
  },
  ja: {
    translation: {
      Anime: 'アニメ',
      'Chinese Painting': '中国画',
      'Choose an artistic style for your image':
        '画像のアートスタイルを選択する',
      Cinematic: '映画風',
      'City skyline at night': '夜の街のスカイライン',
      'Classic theater': '古典演劇',
      'Clear text': 'テキストを消去',
      'Clouds viewed from a mountain peak': '山頂から見た雲',
      Comic: 'コミック',
      'Conference room with view of the mountains':
        '山々を望むカンファレンス ルーム',
      'Cozy living room': '居心地の良いリビングルーム',
      'Coffee shop': 'コーヒーショップ',
      'Create virtual backgrounds with AI Companion': 'バーチャル背景を作成',
      'Add details (optional)': '詳細を追加（オプション）',
      'Describe a background image': '背景画像について説明してください',
      None: 'なし',
      Office: 'オフィス',
      Bookshelf: '本棚',
      Fantasy: 'ファンタジー',
      Generate: '生成',
      Generating: '作成しています',
      'Images failed to generate. Please try again.':
        '画像の生成に失敗しました。もう一度お試しください。',
      'Images may take about a minute to generate.':
        '画像の生成には約 1 分かかる可能性があります',
      'Professional office': 'プロフェッショナルオフィス',
      Space: 'スペース',
      'Style (optional)': 'スタイル（任意）',
      'Select a space': 'スペースを選択してください',
      'Select style': 'スタイルを選択',
      'Tropical beach': 'トロピカルビーチ',
      'We adjusted your prompt to follow our content guidelines':
        'プロンプトはコンテンツガイドラインに合わせて調整しました。',
      'Japanese Ukiyo-E': '日本の浮世絵',
      'Kelp forest': '海藻の群落',
      'Lake in front of mountain during autumn': '秋の山を背にした湖',
      Manga: '漫画',
      'Mid-century modern library': 'ミッドセンチュリー モダン様式の図書館',
      'Modern office overlooking a beach': 'ビーチを見下ろすモダンなオフィス',
      Neonpunk: 'ネオンパンク',
      'Outdoor garden with blooming flowers': '花が咲き誇る屋外庭園',
      'Paper Cut': '切り絵',
      'Pencil Sketch': '鉛筆画',
      'Pixel Art': 'ドット絵',
      'River passing through a canyon': '峡谷を流れる川',
      'Rolling hills at dawn': '明け方のなだらかな丘',
      'Sand dunes during sunset': '日没時の砂丘',
      'Save background': '背景を保存',
      'Showing results': '結果を表示しています',
      'Try again': '再試行',
      'Try these virtual background ideas':
        'これらのバーチャル背景アイディアをお試しください',
      'Text limit has been reached': 'テキストの上限に達しました',
      'Unable to create an image with this prompt. Please try another prompt.':
        'このプロンプトでは画像を作成できません。別のプロンプトを試してください',
      'University lecture hall': '大学の講堂',
      Watercolor: '水彩画',
      'Waterfall in a tropical jungle': '熱帯のジャングルにある滝',
      'Your image has been saved.': '画像が保存されました',
    },
  },
  ko: {
    translation: {
      Anime: '애니메이션',
      'Chinese Painting': '중국화',
      'Choose an artistic style for your image':
        '이미지에 어울리는 예술적인 스타일 선택',
      Cinematic: '시네마틱',
      'City skyline at night': '시티 스카이 라인 야경',
      'Classic theater': '클래식 극장',
      'Clear text': '텍스트 지우기',
      'Clouds viewed from a mountain peak': '산 정상에서 본 구름',
      Comic: '코믹',
      'Conference room with view of the mountains':
        '산을 조망할 수 있는 회의실',
      'Cozy living room': '아늑한 거실',
      'Coffee shop': '커피숍',
      'Create virtual backgrounds with AI Companion': '가상 배경을 만드세요',
      'Add details (optional)': '세부 정보 추가(선택 사항)',
      'Describe a background image': '배경 이미지를 설명하세요',
      None: '없음',
      Office: '사무실',
      Bookshelf: '책장',
      Fantasy: '판타지',
      Generate: '생성',
      Generating: '생성 중',
      'Images failed to generate. Please try again.':
        '이미지를 생성하지 못했습니다. 다시 시도해 주세요.',
      'Images may take about a minute to generate.':
        '이미지를 생성하는 데 약 1분 정도 걸릴 수 있습니다',
      'Professional office': '전문 사무실',
      Space: '공간',
      'Style (optional)': '스타일(선택 사항)',
      'Select a space': '공간 선택',
      'Select style': '스타일 선택',
      'Tropical beach': '열대 해변',
      'We adjusted your prompt to follow our content guidelines':
        '당사의 콘텐츠 가이드라인을 준수하도록 귀하의 프롬프트를 조정했습니다',
      'Japanese Ukiyo-E': '일본 우키요에',
      'Kelp forest': '켈프 숲',
      'Lake in front of mountain during autumn': '가을의 산 앞 호수',
      Manga: '만화',
      'Mid-century modern library': '20세기 중반 현대식 도서관',
      'Modern office overlooking a beach':
        '해변이 내려다 보이는 현대적인 사무실',
      Neonpunk: '네온펑크',
      'Outdoor garden with blooming flowers': '꽃이 만발한 야외 정원',
      'Paper Cut': '종이 자르기',
      'Pencil Sketch': '연필 스케치',
      'Pixel Art': '픽셀 아트',
      'River passing through a canyon': '협곡을 통과하는 강',
      'Rolling hills at dawn': '새벽녘의 구불구불한 언덕',
      'Sand dunes during sunset': '해질녘의 모래 언덕',
      'Save background': '배경 저장',
      'Showing results': '결과 표시 중',
      'Try again': '다시 시도',
      'Try these virtual background ideas':
        '이 가상 배경 아이디어를 시도해 보세요',
      'Text limit has been reached': '텍스트 제한에 도달했습니다',
      'Unable to create an image with this prompt. Please try another prompt.':
        '이 프롬프트로 이미지를 만들 수 없습니다. 다른 프롬프트를 시도하세요',
      'University lecture hall': '대학 강의실',
      Watercolor: '수채화',
      'Waterfall in a tropical jungle': '열대 정글의 폭포',
      'Your image has been saved.': '이미지가 저장되었습니다',
    },
  },
  nl: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Chinese schilderkunst',
      'Choose an artistic style for your image':
        'Kies een artistieke stijl voor uw afbeelding',
      Cinematic: 'Filmisch',
      'City skyline at night': 'Nachtelijke skyline van een stad',
      'Classic theater': 'Klassiek theater',
      'Clear text': 'Tekst wissen',
      'Clouds viewed from a mountain peak': 'Wolken bekeken vanaf een bergtop',
      Comic: 'Stripverhaal',
      'Conference room with view of the mountains':
        'Vergaderruimte met zicht op de bergen',
      'Cozy living room': 'Gezellige woonkamer',
      'Coffee shop': 'Koffiehuis',
      'Create virtual backgrounds with AI Companion':
        'Virtuele achtergronden maken',
      'Add details (optional)': 'Details toevoegen (optioneel)',
      'Describe a background image': 'Beschrijf een achtergrondafbeelding',
      None: 'Geen',
      Office: 'Kantoor',
      Bookshelf: 'Boekenkast',
      Fantasy: 'Fantasy',
      Generate: 'Genereren',
      Generating: 'Bezig met genereren',
      'Images failed to generate. Please try again.':
        'Afbeeldingen genereren mislukt. Probeer het opnieuw.',
      'Images may take about a minute to generate.':
        'Het genereren van de afbeeldingen kan ongeveer een minuut duren',
      'Professional office': 'Professioneel kantoor',
      Space: 'Ruimte',
      'Style (optional)': 'Stijl (optioneel)',
      'Select a space': 'Selecteer een ruimte',
      'Select style': 'Stijl selecteren',
      'Tropical beach': 'Tropisch strand',
      'We adjusted your prompt to follow our content guidelines':
        'We hebben je prompt aangepast zodat deze voldoet aan onze inhoudsrichtlijnen',
      'Japanese Ukiyo-E': 'Japanse ukiyo-e',
      'Kelp forest': 'Kelpwoud',
      'Lake in front of mountain during autumn':
        'Meer voor een berg tijdens de herfst',
      Manga: 'Manga',
      'Mid-century modern library': 'Mid-century moderne bibliotheek',
      'Modern office overlooking a beach':
        'Modern kantoor met uitzicht op een strand',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Buitentuin met bloeiende bloemen',
      'Paper Cut': 'Papierknipsel',
      'Pencil Sketch': 'Potloodschets',
      'Pixel Art': 'Pixelkunst',
      'River passing through a canyon': 'Rivier die door een canyon loopt',
      'Rolling hills at dawn': 'Glooiende heuvels bij zonsopgang',
      'Sand dunes during sunset': 'Zandduinen tijdens zonsondergang',
      'Save background': 'Achtergrond opslaan',
      'Showing results': 'Resultaten weergeven',
      'Try again': 'Opnieuw proberen',
      'Try these virtual background ideas':
        'Probeer deze ideeën voor virtuele achtergronden',
      'Text limit has been reached': 'Tekstlimiet is bereikt',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Er kan geen afbeelding worden gemaakt met deze prompt. Probeer een andere prompt',
      'University lecture hall': 'Collegezaal van een universiteit',
      Watercolor: 'Waterverf',
      'Waterfall in a tropical jungle': 'Waterval in een tropische jungle',
      'Your image has been saved.': 'Uw afbeelding is opgeslagen',
    },
  },
  pl: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Obraz w stylu chińskim',
      'Choose an artistic style for your image':
        'Wybierz styl artystyczny dla swojego obrazu',
      Cinematic: 'Kinowy',
      'City skyline at night': 'Panorama miasta nocą',
      'Classic theater': 'Teatr klasyczny',
      'Clear text': 'Wyczyść tekst',
      'Clouds viewed from a mountain peak':
        'Chmury widziane z górskiego szczytu',
      Comic: 'Komik',
      'Conference room with view of the mountains':
        'Sala konferencyjna z widokiem na góry',
      'Cozy living room': 'Przytulny salon',
      'Coffee shop': 'Kawiarnia',
      'Create virtual backgrounds with AI Companion': 'Utwórz wirtualne tła',
      'Add details (optional)': 'Dodaj szczegóły (opcjonalnie)',
      'Describe a background image': 'Opisz, jak ma wyglądać tło',
      None: 'Brak',
      Office: 'Biuro',
      Bookshelf: 'Biblioteczka',
      Fantasy: 'Fantasy',
      Generate: 'Generuj',
      Generating: 'Generowanie',
      'Images failed to generate. Please try again.':
        'Nie udało się wygenerować obrazów. Spróbuj ponownie.',
      'Images may take about a minute to generate.':
        'Generowanie obrazów może potrwać około minuty',
      'Professional office': 'Profesjonalne biuro',
      Space: 'Otoczenie',
      'Style (optional)': 'Styl (opcjonalnie)',
      'Select a space': 'Wybierz otoczenie',
      'Select style': 'Wybierz styl',
      'Tropical beach': 'Tropikalna plaża',
      'We adjusted your prompt to follow our content guidelines':
        'Dostosowaliśmy Twój prompt, aby był zgodny z naszymi wytycznymi dotyczącymi treści',
      'Japanese Ukiyo-E': 'Japoński Ukiyo-E',
      'Kelp forest': 'Las wodorostów',
      'Lake in front of mountain during autumn': 'Jezioro pod górami jesienią',
      Manga: 'Manga',
      'Mid-century modern library': 'Nowoczesna biblioteka z połowy wieku',
      'Modern office overlooking a beach':
        'Nowoczesne biuro z widokiem na plażę',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Ogród na świeżym powietrzu z kwitnącymi kwiatami',
      'Paper Cut': 'Wycinanka z papieru',
      'Pencil Sketch': 'Szkic ołówkiem',
      'Pixel Art': 'Pixel Art',
      'River passing through a canyon': 'Rzeka przepływająca przez kanion',
      'Rolling hills at dawn': 'Wzgórza o świcie',
      'Sand dunes during sunset': 'Wydmy o zachodzie słońca',
      'Save background': 'Zapisz tło',
      'Showing results': 'Wyświetlanie wyników',
      'Try again': 'Spróbuj ponownie',
      'Try these virtual background ideas':
        'Wypróbuj te pomysły na wirtualne tło',
      'Text limit has been reached': 'Osiągnięto limit tekstu',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Nie można utworzyć obrazu z tym monitem. Spróbuj użyć innego monitu',
      'University lecture hall': 'Uniwersytecka sala wykładowa',
      Watercolor: 'Akwarela',
      'Waterfall in a tropical jungle': 'Wodospad w tropikalnej dżungli',
      'Your image has been saved.': 'Twój obraz został zapisany',
    },
  },
  pt: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Pintura chinesa',
      'Choose an artistic style for your image':
        'Escolha um estilo artístico para sua imagem',
      Cinematic: 'Cinematográfica',
      'City skyline at night': 'Skyline da cidade na noite',
      'Classic theater': 'Teatro clássico',
      'Clear text': 'Limpar texto',
      'Clouds viewed from a mountain peak':
        'Nuvens vistas de um pico de montanha',
      Comic: 'Cômico',
      'Conference room with view of the mountains':
        'Sala de conferências com vista para as montanhas',
      'Cozy living room': 'Sala de estar aconchegante',
      'Coffee shop': 'Cafeteria',
      'Create virtual backgrounds with AI Companion':
        'Crie planos de fundo virtuais',
      'Add details (optional)': 'Adicione detalhes (opcional)',
      'Describe a background image':
        'Descreva uma imagem de plano de fundo',
      None: 'Nenhum',
      Office: 'Escritório',
      Bookshelf: 'Estante de livros',
      Fantasy: 'Fantasia',
      Generate: 'Gerar',
      Generating: 'Gerando',
      'Images failed to generate. Please try again.':
        'As imagens não foram geradas. Tente novamente.',
      'Images may take about a minute to generate.':
        'As imagens podem levar cerca de um minuto para serem geradas',
      'Professional office': 'Escritório profissional',
      Space: 'Espaço',
      'Style (optional)': 'Estilo (opcional)',
      'Select a space': 'Selecione um espaço',
      'Select style': 'Selecione o estilo',
      'Tropical beach': 'Praia tropical',
      'We adjusted your prompt to follow our content guidelines':
        'Ajustamos seu prompt para seguir nossas diretrizes de conteúdo',
      'Japanese Ukiyo-E': 'Ukiyo-E japonês',
      'Kelp forest': 'Floresta de algas marinhas',
      'Lake in front of mountain during autumn':
        'Lago em frente à montanha durante o outono',
      Manga: 'Manga',
      'Mid-century modern library': 'Biblioteca moderna de meados do século',
      'Modern office overlooking a beach':
        'Escritório moderno com vista para uma praia',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Jardim ao ar livre com flores desabrochando',
      'Paper Cut': 'Corte de papel',
      'Pencil Sketch': 'Esboço a lápis',
      'Pixel Art': 'Pixel Art',
      'River passing through a canyon': 'Rio passando por um desfiladeiro',
      'Rolling hills at dawn': 'Colinas ao amanhecer',
      'Sand dunes during sunset': 'Dunas de areia durante o pôr do sol',
      'Save background': 'Salvar plano de fundo',
      'Showing results': 'Mostrando resultados',
      'Try again': 'Tente novamente',
      'Try these virtual background ideas':
        'Experimente estas ideias de plano de fundo virtual',
      'Text limit has been reached': 'O limite de texto foi atingido',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Não é possível criar uma imagem com este prompt. Tente outro prompt',
      'University lecture hall': 'Sala de aula universitária',
      Watercolor: 'Aquarela',
      'Waterfall in a tropical jungle': 'Cachoeira em uma selva tropical',
      'Your image has been saved.': 'Sua imagem foi salva',
    },
  },
  ru: {
    translation: {
      Anime: 'Аниме',
      'Chinese Painting': 'Китайская живопись',
      'Choose an artistic style for your image': 'Выберите стиль изображения',
      Cinematic: 'Кинематографичное изображение',
      'City skyline at night': 'Городской пейзаж ночью',
      'Classic theater': 'Классический театр',
      'Clear text': 'Очистить текст',
      'Clouds viewed from a mountain peak': 'Вид на облака с вершины горы',
      Comic: 'Комический',
      'Conference room with view of the mountains':
        'Конференц-зал с видом на горы',
      'Cozy living room': 'Уютная гостиная',
      'Coffee shop': 'Кофейня',
      'Create virtual backgrounds with AI Companion':
        'Создайте виртуальные фоны',
      'Add details (optional)': 'Добавить сведения (необязательно)',
      'Describe a background image': 'Опишите, что нужно на фоне',
      None: 'Нет',
      Office: 'Офис',
      Bookshelf: 'Книжная полка',
      Fantasy: 'Фэнтези',
      Generate: 'Создать',
      Generating: 'Идет создание',
      'Images failed to generate. Please try again.':
        'Не удалось создать изображения. Повторите попытку.',
      'Images may take about a minute to generate.':
        'Создание изображений может занять около минуты',
      'Professional office': 'Офис',
      Space: 'Космос',
      'Style (optional)': 'Стиль (необязательно)',
      'Select a space': 'Выберите пространство',
      'Select style': 'Выберите стиль',
      'Tropical beach': 'Тропический пляж',
      'We adjusted your prompt to follow our content guidelines':
        'Мы скорректировали ваш запрос, чтобы он соответствовал нашим правилам контента.',
      'Japanese Ukiyo-E': 'Японская живопись укиё-э',
      'Kelp forest': 'Лес водорослей',
      'Lake in front of mountain during autumn': 'Горное озеро осенью',
      Manga: 'Манга',
      'Mid-century modern library': 'Современная библиотека середины века',
      'Modern office overlooking a beach': 'Современный офис с видом на пляж',
      Neonpunk: 'Неон-панк',
      'Outdoor garden with blooming flowers': 'Цветущий сад',
      'Paper Cut': 'Аппликация',
      'Pencil Sketch': 'Карандашный набросок',
      'Pixel Art': 'Пиксельная графика',
      'River passing through a canyon': 'Река, протекающая через каньон',
      'Rolling hills at dawn': 'Гряда холмов на закате',
      'Sand dunes during sunset': 'Песчаные дюны на закате',
      'Save background': 'Сохранить фон',
      'Showing results': 'Отображение результатов',
      'Try again': 'Повторить',
      'Try these virtual background ideas': 'Попробуйте эти виртуальные фоны',
      'Text limit has been reached': 'Достигнут лимит текста',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Не удалось создать изображение по этому запросу. Попробуйте другой запрос',
      'University lecture hall': 'Лекционная аудитория в университете',
      Watercolor: 'Акварель',
      'Waterfall in a tropical jungle': 'Водопад в тропических джунглях',
      'Your image has been saved.': 'Изображение сохранено',
    },
  },
  sv: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Kinesisk målning',
      'Choose an artistic style for your image':
        'Välj en konstnärlig stil för din bild',
      Cinematic: 'Filmisk',
      'City skyline at night': 'Stadssilhuett på natten',
      'Classic theater': 'Klassisk teater',
      'Clear text': 'Rensa text',
      'Clouds viewed from a mountain peak': 'Moln sedda från en bergstopp',
      Comic: 'Serietidning',
      'Conference room with view of the mountains':
        'Konferensrum med utsikt över bergen',
      'Cozy living room': 'Mysigt vardagsrum',
      'Coffee shop': 'Kafé',
      'Create virtual backgrounds with AI Companion':
        'Skapa virtuella bakgrunder',
      'Add details (optional)': 'Lägg till detaljer (valfritt)',
      'Describe a background image': 'Beskriv en bakgrundsbild',
      None: 'Inget',
      Office: 'Kontor',
      Bookshelf: 'Bokhylla',
      Fantasy: 'Fantasy',
      Generate: 'Generera',
      Generating: 'Genererar',
      'Images failed to generate. Please try again.':
        'Det gick inte att generera bilder. Försök igen.',
      'Images may take about a minute to generate.':
        'Bilderna tar ungefär en minut att generera',
      'Professional office': 'Professionellt kontor',
      Space: 'Utrymme',
      'Style (optional)': 'Stil (valfritt)',
      'Select a space': 'Välj ett utrymme',
      'Select style': 'Välj stil',
      'Tropical beach': 'Tropisk strand',
      'We adjusted your prompt to follow our content guidelines':
        'Vi har anpassat din prompt så att den följer våra innehållsriktlinjer',
      'Japanese Ukiyo-E': 'Japansk Ukiyo-E',
      'Kelp forest': 'Kelpskog',
      'Lake in front of mountain during autumn':
        'Sjö framför berg under hösten',
      Manga: 'Manga',
      'Mid-century modern library':
        'Modernt bibliotek från mitten av århundradet',
      'Modern office overlooking a beach':
        'Modernt kontor med utsikt över en strand',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers': 'Trädgård med blomsterprakt',
      'Paper Cut': 'Pappersklipp',
      'Pencil Sketch': 'Blyertsskiss',
      'Pixel Art': 'Pixelkonst',
      'River passing through a canyon': 'Flod som passerar genom en kanjon',
      'Rolling hills at dawn': 'Böljande kullar i gryningen',
      'Sand dunes during sunset': 'Sanddyner i solnedgång',
      'Save background': 'Spara bakgrund',
      'Showing results': 'Visar resultat',
      'Try again': 'Försök igen',
      'Try these virtual background ideas':
        'Prova de här idéerna för virtuell bakgrund',
      'Text limit has been reached': 'Textgränsen har nåtts',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Det går inte att skapa en bild med den här uppmaningen. Försök med en annan uppmaning',
      'University lecture hall': 'Föreläsningssal på universitet',
      Watercolor: 'Vattenfärg',
      'Waterfall in a tropical jungle': 'Vattenfall i en tropisk djungel',
      'Your image has been saved.': 'Din bild har sparats',
    },
  },
  tr: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Çin Resim Sanatı',
      'Choose an artistic style for your image':
        'Resminiz için sanatsal bir stil seçin',
      Cinematic: 'Sinematik',
      'City skyline at night': 'Gece şehir silüeti',
      'Classic theater': 'Klasik tiyatro',
      'Clear text': 'Metni temizle',
      'Clouds viewed from a mountain peak':
        'Bir dağın zirvesinden görünen bulutlar',
      Comic: 'Çizgi roman',
      'Conference room with view of the mountains':
        'Dağ manzaralı konferans salonu',
      'Cozy living room': 'Rahat oturma odası',
      'Coffee shop': 'Kafe',
      'Create virtual backgrounds with AI Companion':
        'Sanal arka planlar oluştur',
      'Add details (optional)': 'Ayrıntıları ekleyin (isteğe bağlı)',
      'Describe a background image': 'Arka plan resmini tarif edin',
      None: 'Yok',
      Office: 'Ofis',
      Bookshelf: 'Kitaplık',
      Fantasy: 'Fantastik',
      Generate: 'Oluştur',
      Generating: 'Oluşturuluyor',
      'Images failed to generate. Please try again.':
        'Resimler oluşturulamadı. Lütfen yeniden deneyin.',
      'Images may take about a minute to generate.':
        'Resimlerin oluşturulması yaklaşık bir dakika sürebilir',
      'Professional office': 'Profesyonel ofis',
      Space: 'Alan',
      'Style (optional)': 'Stil (isteğe bağlı)',
      'Select a space': 'Bir alan seçin',
      'Select style': 'Stil seçin',
      'Tropical beach': 'Tropikal plaj',
      'We adjusted your prompt to follow our content guidelines':
        'İsteminizi içerik yönergelerimize uygun olacak şekilde düzenledik',
      'Japanese Ukiyo-E': 'Japonca Ukiyo-E',
      'Kelp forest': 'Yosun ormanı',
      'Lake in front of mountain during autumn': 'Sonbaharda dağ eteğinde göl',
      Manga: 'Manga',
      'Mid-century modern library': 'Yüzyıl ortası modern kütüphane',
      'Modern office overlooking a beach': 'Plaja bakan modern ofis',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Açmış çiçeklerle dış mekan bahçesi',
      'Paper Cut': 'Kağıt Kesme',
      'Pencil Sketch': 'Kalem Eskizi',
      'Pixel Art': 'Piksel Sanatı',
      'River passing through a canyon': 'Bir kanyondan geçen nehir',
      'Rolling hills at dawn': 'Şafakta tepeler',
      'Sand dunes during sunset': 'Gün batımında kum tepeleri',
      'Save background': 'Arka planı kaydet',
      'Showing results': 'Sonuçlar gösteriliyor',
      'Try again': 'Tekrar deneyin',
      'Try these virtual background ideas':
        'Bu sanal arka plan fikirlerini deneyin',
      'Text limit has been reached': 'Metin sınırına ulaşıldı',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Bu istemle bir resim oluşturulamıyor. Lütfen başka bir istem deneyin',
      'University lecture hall': 'Üniversite amfisi',
      Watercolor: 'Suluboya',
      'Waterfall in a tropical jungle': 'Tropikal bir ormanda şelale',
      'Your image has been saved.': 'Resminiz kaydedildi',
    },
  },
  vi: {
    translation: {
      Anime: 'Anime',
      'Chinese Painting': 'Hội họa Trung Quốc',
      'Choose an artistic style for your image':
        'Chọn một phong cách nghệ thuật cho hình ảnh',
      Cinematic: 'Điện ảnh',
      'City skyline at night': 'Đường chân trời của thành phố về đêm',
      'Classic theater': 'Nhà hát cổ điển',
      'Clear text': 'Xóa văn bản',
      'Clouds viewed from a mountain peak': 'Mây nhìn từ đỉnh núi',
      Comic: 'Truyện tranh',
      'Conference room with view of the mountains':
        'Phòng hội nghị nhìn ra núi',
      'Cozy living room': 'Phòng khách ấm cúng',
      'Coffee shop': 'Quán cà phê',
      'Create virtual backgrounds with AI Companion': 'Tạo nền ảo',
      'Add details (optional)': 'Thêm thông tin (không bắt buộc)',
      'Describe a background image': 'Mô tả ảnh nền',
      None: 'Không có',
      Office: 'Văn phòng',
      Bookshelf: 'Kệ sách',
      Fantasy: 'Kỳ ảo',
      Generate: 'Tạo',
      Generating: 'Đang tạo',
      'Images failed to generate. Please try again.':
        'Không tạo được hình ảnh. Vui lòng thử lại.',
      'Images may take about a minute to generate.':
        'Quá trình tạo hình ảnh có thể mất khoảng một phút',
      'Professional office': 'Văn phòng chuyên nghiệp',
      Space: 'Không gian',
      'Style (optional)': 'Kiểu (tùy chọn)',
      'Select a space': 'Chọn không gian',
      'Select style': 'Chọn kiểu',
      'Tropical beach': 'Bãi biển nhiệt đới',
      'We adjusted your prompt to follow our content guidelines':
        'Chúng tôi đã điều chỉnh câu lệnh của bạn để tuân thủ nguyên tắc nội dung của chúng tôi.',
      'Japanese Ukiyo-E': 'Ukiyo-E của Nhật',
      'Kelp forest': 'Rừng tảo bẹ',
      'Lake in front of mountain during autumn': 'Hồ trước núi vào mùa thu',
      Manga: 'Manga',
      'Mid-century modern library': 'Thư viện hiện đại giữa thế kỷ',
      'Modern office overlooking a beach':
        'Văn phòng hiện đại nhìn ra bãi biển',
      Neonpunk: 'Neonpunk',
      'Outdoor garden with blooming flowers':
        'Khu vườn ngoài trời với những bông hoa nở rộ',
      'Paper Cut': 'Cắt giấy',
      'Pencil Sketch': 'Phác thảo chì',
      'Pixel Art': 'Nghệ thuật pixel',
      'River passing through a canyon': 'Sông chảy qua một hẻm núi',
      'Rolling hills at dawn': 'Những ngọn đồi thoai thoải lúc bình minh',
      'Sand dunes during sunset': 'Cồn cát lúc hoàng hôn',
      'Save background': 'Lưu nền',
      'Showing results': 'Hiển thị kết quả',
      'Try again': 'Thử lại',
      'Try these virtual background ideas': 'Hãy thử những ý tưởng nền ảo này',
      'Text limit has been reached': 'Đã đạt đến giới hạn văn bản',
      'Unable to create an image with this prompt. Please try another prompt.':
        'Không thể tạo hình ảnh với câu lệnh này. Vui lòng thử câu lệnh khác',
      'University lecture hall': 'Giảng đường đại học',
      Watercolor: 'Màu nước',
      'Waterfall in a tropical jungle': 'Thác nước trong rừng nhiệt đới',
      'Your image has been saved.': 'Hình ảnh của bạn đã được lưu',
    },
  },
  'zh-CN': {
    translation: {
      Anime: '动漫',
      'Chinese Painting': '国画',
      'Choose an artistic style for your image': '为你的图片选择一种艺术风格',
      Cinematic: '电影',
      'City skyline at night': '夜晚的城市天际线',
      'Classic theater': '经典剧院',
      'Clear text': '清除文本',
      'Clouds viewed from a mountain peak': '从山顶上眺望云海',
      Comic: '连环漫画',
      'Conference room with view of the mountains': '山景会议室',
      'Cozy living room': '舒适的客厅',
      'Coffee shop': '咖啡店',
      'Create virtual backgrounds with AI Companion': '创建虚拟背景',
      'Add details (optional)': '添加详情（可选）',
      'Describe a background image': '描述背景图片',
      None: '无',
      Office: '办公室',
      Bookshelf: '书架',
      Fantasy: '幻想',
      Generate: '生成',
      Generating: '正在生成',
      'Images failed to generate. Please try again.': '无法生成图片。请重试。',
      'Images may take about a minute to generate.':
        '生成图片可能需要大约一分钟',
      'Professional office': '专业办公室',
      Space: '空间',
      'Style (optional)': '风格（可选）',
      'Select a space': '选择空间',
      'Select style': '选择风格',
      'Tropical beach': '热带海滩',
      'We adjusted your prompt to follow our content guidelines':
        '我们根据内容指南，对你的提示进行了调整',
      'Japanese Ukiyo-E': '日本浮世绘',
      'Kelp forest': '海藻森林',
      'Lake in front of mountain during autumn': '秋季山前湖景',
      Manga: '漫画',
      'Mid-century modern library': '中世纪风的现代图书馆',
      'Modern office overlooking a beach': '俯瞰海滩的现代办公室',
      Neonpunk: '霓虹朋克',
      'Outdoor garden with blooming flowers': '花团锦簇的户外花园',
      'Paper Cut': '剪纸',
      'Pencil Sketch': '铅笔素描',
      'Pixel Art': '像素艺术',
      'River passing through a canyon': '穿过峡谷的河流',
      'Rolling hills at dawn': '黎明时分连绵起伏的丘陵',
      'Sand dunes during sunset': '日落时分的沙丘',
      'Save background': '保存背景',
      'Showing results': '正在显示结果',
      'Try again': '请重试',
      'Try these virtual background ideas': '试试这些创意虚拟背景',
      'Text limit has been reached': '已达到文本长度上限',
      'Unable to create an image with this prompt. Please try another prompt.':
        '无法使用此提示创建图片。请尝试其他提示',
      'University lecture hall': '大学报告厅',
      Watercolor: '水彩',
      'Waterfall in a tropical jungle': '热带丛林中的瀑布',
      'Your image has been saved.': '你的图片已保存',
    },
  },
  'zh-TW': {
    translation: {
      Anime: '動畫',
      'Chinese Painting': '中國畫',
      'Choose an artistic style for your image': '為您的影像選擇一種藝術風格',
      Cinematic: '電影',
      'City skyline at night': '夜晚的城市天際線',
      'Classic theater': '經典戲院',
      'Clear text': '清除文字',
      'Clouds viewed from a mountain peak': '從山頂眺望雲彩',
      Comic: '連環漫畫',
      'Conference room with view of the mountains': '擁有山景的會議室',
      'Cozy living room': '舒適的客廳',
      'Coffee shop': '咖啡館',
      'Create virtual backgrounds with AI Companion': '建立虛擬背景',
      'Add details (optional)': '新增詳細資訊（選用）',
      'Describe a background image': '說明背景影像',
      None: '無',
      Office: '辦公室',
      Bookshelf: '書架',
      Fantasy: '幻想',
      Generate: '產生',
      Generating: '正在生成',
      'Images failed to generate. Please try again.':
        '無法產生影像。請再試一次。',
      'Images may take about a minute to generate.':
        '可能需要約一分鐘的時間來產生影像',
      'Professional office': '專業辦公室',
      Space: '空間',
      'Style (optional)': '樣式（選用）',
      'Select a space': '選取一個空間',
      'Select style': '選取樣式',
      'Tropical beach': '熱帶海灘',
      'We adjusted your prompt to follow our content guidelines':
        '我們調整了您的提示以跟隨我們的內容指南',
      'Japanese Ukiyo-E': '日本浮世繪',
      'Kelp forest': '海藻林',
      'Lake in front of mountain during autumn': '秋季山前湖景',
      Manga: '漫畫',
      'Mid-century modern library': '中世紀風的現代圖書館',
      'Modern office overlooking a beach': '俯瞰海灘的現代化辦公室',
      Neonpunk: '霓虹龐克',
      'Outdoor garden with blooming flowers': '花團錦簇的室外花園',
      'Paper Cut': '剪紙',
      'Pencil Sketch': '鉛筆素描',
      'Pixel Art': '像素藝術',
      'River passing through a canyon': '流經峽谷的河流',
      'Rolling hills at dawn': '拂曉時分連綿起伏的山巒',
      'Sand dunes during sunset': '日落時分的沙丘',
      'Save background': '儲存背景',
      'Showing results': '正在顯示結果',
      'Try again': '請再試一次',
      'Try these virtual background ideas': '試試這些虛擬背景構思',
      'Text limit has been reached': '已達到文字數上限。',
      'Unable to create an image with this prompt. Please try another prompt.':
        '無法使用此提示建立影像。請嘗試另一個提示',
      'University lecture hall': '大學演講廳',
      Watercolor: '水彩',
      'Waterfall in a tropical jungle': '熱帶叢林中的瀑布',
      'Your image has been saved.': '已儲存您的影像',
    },
  },
}

export default resources
